import { Box, chakra, VStack, Heading, Flex, IconButton, Icon, useDisclosure, Tooltip } from '@chakra-ui/react'
import React from 'react'
import { useForm } from 'react-hook-form'
import FormButton from '../../../../components/Forms/FormButton'
import FormInput from '../../../../components/Forms/FormInput'
import { EMAIL_REGEX } from '../../../../config/constants/regexConstants'
import FormSwitch from '../../../../components/Forms/FormSwitch'
import { useVimeoSettings, useUpdateVimeoSettings } from '../../../../config/query/settingQuery'
import FormFieldsSkeleton from '../../../../components/Skeletons/FormFieldsSkeleton'
import APP_ICONS from '../../../../config/constants/icons'


const VimeoSettings = () => {
    const editDisclosure = useDisclosure()

    const vimeoSettingsQuery = useVimeoSettings()
    const updateVimeoSettingsQuery = useUpdateVimeoSettings()

    const {
        handleSubmit,
        control,
        setValue,
        getValues,
        watch,
        formState: { errors },
    } = useForm({
        values: vimeoSettingsQuery.data
    })

    function onSubmit(values) {
        updateVimeoSettingsQuery.mutate(values)
    }

    return (
        <Box>
            <chakra.form onSubmit={handleSubmit(onSubmit)}>
                <Flex align={"center"} justify={"space-between"} maxW="500px">
                    <Heading fontSize={"20px"}>Vimeo Settings</Heading>
                    <Tooltip label={editDisclosure.isOpen ? "Close" : "Edit"} aria-label="A tooltip">
                        <IconButton
                            icon={<Icon
                                boxSize={editDisclosure.isOpen ? "0.8em" : "1.25em"}
                                as={editDisclosure.isOpen ? APP_ICONS.CLOSE : APP_ICONS.EDIT}
                            />}
                            onClick={() => editDisclosure.onToggle()}
                        />
                    </Tooltip>
                </Flex>
                <Box mt={4} maxW="500px">

                    {vimeoSettingsQuery.isLoading
                        ? <FormFieldsSkeleton columns={1} count={1} />
                        : <VStack spacing={4} align={"stretch"}>

                            <FormInput
                                id={"accessToken"}
                                label="Access Token"
                                placeholder="Enter vimeo access token"
                                required={true}
                                errors={errors}
                                control={control}
                                inputProps={{
                                    isDisabled: updateVimeoSettingsQuery.isLoading || !editDisclosure.isOpen
                                }}
                                rules={{
                                    validate: (value) => {
                                        if (value.length < 32) return "Please enter a valid access token"
                                    }
                                }}
                            />

                            {editDisclosure.isOpen && (
                                <FormButton
                                    mr="auto"
                                    isLoading={updateVimeoSettingsQuery.isLoading}
                                    type="submit"
                                    containerStyles={{ textAlignLast: "right" }}
                                >
                                    Save Changes
                                </FormButton>
                            )}

                        </VStack>
                    }



                </Box>

            </chakra.form>
        </Box>
    )
}

export default VimeoSettings